<template>
    <div class="container">
        asdasd
    </div>
</template>

<script>
    export default {
        name: "login",
        data(){
            return {

            }
        },
        methods:{

        }
    }
</script>

<style scoped lang="scss">
div.container {
    background: url("./../assets/images/login-bg.jpg");
}
</style>
